import { createSlotsContext } from '@grandvisionhq/slots';

const [CCCAddressFormSlotsProvider, useCCCAddressFormSlots] = createSlotsContext({
    displayName: 'CCCAddressFormSlotsContext'
});

export { CCCAddressFormSlotsProvider, useCCCAddressFormSlots };
//# sourceMappingURL=CCCAddressFormSlotsContext.js.map
